<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Dormant List
                  </v-toolbar-title>
                </div>
                <div class="ml-auto">
                  <v-btn color="primary" @click.prevent="goBack()">
                    <v-icon class="mr-2">mdi-arrow-left</v-icon> Back
                  </v-btn>
                </div>
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="id"
            :search="search"
            loading-text="Loading... Please wait"
            class="elevation-1"
          >
            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  name: "DormantList",
  components: {},
  data() {
    return {
      addDealerDialog: {
        dialog: false,
      },

      dealerViewSales: {
        dialog: false,
        data: {},
      },

      search: "",
      table: {
        // sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        headers: [
          {
            text: "Name",
            align: "start",
            value: "name",
          },
          {
            text: "City",
            align: "start",
            value: "city",
          },
          {
            text: "Dealer",
            align: "start",
            value: "dealer",
          },
          {
            text: "Acquirer",
            align: "start",
            value: "acquirer",
          },
          {
            text: "Last Top-up Date",
            align: "start",
            value: "lastTopUpDate",
            formatter: (x) =>
              x && x != "NA"
                ? moment(x).format("MMM DD, YYYY h:mm:ss A")
                : "NA",
          },
        ],
        data: [],
      },
    };
  },

  methods: {
    async getList() {
      this.table.loading = true;
      await this.$api
        .get("/acquisition/report?report=dormant-details")
        .then((response) => {
          const newArr = response.data.data;
          this.table.data = newArr.list;
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    goBack() {
      this.$router.go(-1);
    },
  },
  created() {
    this.getList();
  },

  watch: {},

  computed: {},
};
</script>
